import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/styles/App.less';
import { lazy, Suspense } from 'react';
import ReactModal from 'react-modal';
import { BrowserRouter, Outlet, Route, Routes, useParams } from 'react-router-dom';
import SideBar from '@/components/Navigation/SideBar';
import Loader from '@/components/UI/Loader';
import { CombatLogsProvider } from '@/context/CombatLogsContext';
import { CardsProvider } from '@/context/InitiativeTrackerContext';
import AuthGate from '@/pages/Auth/AuthPage';
import BoardPage from '@/pages/Board/BoardPage';
// import SpellsPage from '@/pages/SpellsPage/SpellsPage';
import BoardsList from '@/pages/Board/BoardsList';
import CharactersPage from '@/pages/Characters/CharactersPage';
import CombatMapsPage from '@/pages/CombatMaps/CombatMapsPage';
import InitiativeTracker from '@/pages/InitiativeTracker/InitiativeTracker';
import ProfilePage from '@/pages/Profile/ProfilePage';
import InitiativeTrackerRoom from '@/pages/Rooms/InitiativeTrackerRoom';
import RoomsPage from '@/pages/Rooms/RoomsPage';
ReactModal.setAppElement('#root');
const SpellsPage = lazy(() => import('@/pages/SpellsPage/SpellsPage'));
// Обёртка для передачи roomCode из URL в Room
function RoomRouteWrapper() {
    const { roomCode } = useParams();
    if (!roomCode)
        return _jsx("div", { children: "\u041A\u043E\u043C\u043D\u0430\u0442\u0430 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430" });
    return _jsx(InitiativeTrackerRoom, { roomCode: roomCode });
}
// Обёртка для передачи code из URL в Board
function BoardRouteWrapper() {
    const { code } = useParams();
    if (!code)
        return _jsx("div", { children: "\u0414\u043E\u0441\u043A\u0430 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430" });
    return _jsx(BoardPage, { slug: code });
}
const AppLayout = () => (_jsxs("div", { className: "App", children: [_jsx(SideBar, {}), _jsx(Outlet, {})] }));
const App = () => (_jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsxs(Route, { element: _jsx(AppLayout, {}), children: [_jsx(Route, { index: true, element: _jsx(AuthGate, {}) }), _jsx(Route, { path: "auth", element: _jsx(AuthGate, {}) }), _jsx(Route, { path: "profile", element: _jsx(ProfilePage, {}) }), _jsx(Route, { path: "spells", element: _jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(SpellsPage, {}) }) }), _jsx(Route, { path: "characters", element: _jsx(CharactersPage, {}) }), _jsx(Route, { path: "combat-maps", element: _jsx(CombatMapsPage, {}) }), _jsx(Route, { path: "initiative-tracker", element: _jsx(CombatLogsProvider, { children: _jsx(CardsProvider, { children: _jsx(InitiativeTracker, {}) }) }) }), _jsx(Route, { path: "rooms", element: _jsx(RoomsPage, {}) }), _jsx(Route, { path: "room/:roomCode", element: _jsx(CombatLogsProvider, { children: _jsx(CardsProvider, { children: _jsx(RoomRouteWrapper, {}) }) }) }), _jsx(Route, { path: "boards", element: _jsx(BoardsList, {}) }), _jsx(Route, { path: "boards/:code", element: _jsx(BoardRouteWrapper, {}) })] }) }) }));
export default App;
